export const StringTimeFormat = (time) => {
  if(time){
  const splittedTime = time?.split(":")
  const hours =  parseInt(splittedTime[0], 10)
  const minute = splittedTime[1]
  if(hours===12){
    return `${hours}:${minute} PM`
  }
  else if(hours>12){
    const convertedhours = hours-12
       return `${convertedhours.toString().padStart(2, "0")}:${minute} PM` 
  }
 else if(hours===0){
    return `12:${minute} AM`
  }
  else {
        return `${time} AM`
  }
}
}